function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos()
}
window.theme = window.theme || {}, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(e, t) {
            var i = $(e),
                n = i.attr("data-section-id"),
                a = i.attr("data-section-type");
            if (t = t || this.constructors[a], !_.isUndefined(t)) {
                var r = _.assignIn(new t(e), {
                    id: n,
                    type: a,
                    container: e
                });
                this.instances.push(r)
            }
        },
        _onSectionLoad: function(e) {
            var t = $("[data-section-id]", e.target)[0];
            t && this._createInstance(t)
        },
        _onSectionUnload: function(e) {
            this.instances = _.filter(this.instances, function(t) {
                var i = t.id === e.detail.sectionId;
                return i && _.isFunction(t.onUnload) && t.onUnload(e), !i
            })
        },
        _onSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e)
        },
        _onDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e)
        },
        _onBlockSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e)
        },
        _onBlockDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e)
        },
        register: function(e, t) {
            this.constructors[e] = t, $("[data-section-type=" + e + "]").each(function(e, i) {
                this._createInstance(i, t)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.utils = {
        getParameterByName: function(e, t) {
            t || (t = window.location.href), e = e.replace(/[[\]]/g, "\\$&");
            var i = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
            return i ? i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "" : null
        },
        keyboardKeys: {
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27,
            LEFTARROW: 37,
            RIGHTARROW: 39
        }
    }, window.slate = window.slate || {}, slate.rte = {
        wrapTable: function(e) {
            e.$tables.wrap('<div class="' + e.tableWrapperClass + '"></div>')
        },
        wrapIframe: function(e) {
            e.$iframes.each(function() {
                $(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'), this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(e) {
            var t = "js-focus-hidden";
            e.first().attr("tabIndex", "-1").focus().addClass(t).one("blur", function() {
                e.first().removeClass(t).removeAttr("tabindex")
            })
        },
        focusHash: function() {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", function(e) {
                this.pageLinkFocus($(e.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function(e) {
            var t = {
                    focusin: e.namespace ? "focusin." + e.namespace : "focusin",
                    focusout: e.namespace ? "focusout." + e.namespace : "focusout",
                    keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus"
                },
                i = e.$container.find($('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(":visible")),
                n = i[0],
                a = i[i.length - 1];
            e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(t.focusout, function() {
                $(document).off(t.keydown)
            }), $(document).on(t.focusin, function(e) {
                e.target !== a && e.target !== n || $(document).on(t.keydown, function(e) {
                    ! function(e) {
                        e.keyCode === slate.utils.keyboardKeys.TAB && (e.target !== a || e.shiftKey || (e.preventDefault(), n.focus()), e.target === n && e.shiftKey && (e.preventDefault(), a.focus()))
                    }(e)
                })
            })
        },
        removeTrapFocus: function(e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t)
        },
        accessibleLinks: function(e) {
            var t = document.querySelector("body"),
                i = {
                    newWindow: "a11y-new-window-message",
                    external: "a11y-external-message",
                    newWindowExternal: "a11y-new-window-external-message"
                };
            void 0 !== e.$links && e.$links.jquery || (e.$links = $("a[href]:not([aria-describedby])")), $.each(e.$links, function() {
                    var e = $(this),
                        t = e.attr("target"),
                        n = e.attr("rel"),
                        a = function(e) {
                            var t = window.location.hostname;
                            return e[0].hostname !== t
                        }(e),
                        r = "_blank" === t;
                    a && e.attr("aria-describedby", i.external), r && (void 0 !== n && -1 !== n.indexOf("noopener") || e.attr("rel", function(e, t) {
                        return (void 0 === t ? "" : t + " ") + "noopener"
                    }), e.attr("aria-describedby", i.newWindow)), a && r && e.attr("aria-describedby", i.newWindowExternal)
                }),
                function(e) {
                    "object" != typeof e && (e = {});
                    var n = $.extend({
                            newWindow: "Opens in a new window.",
                            external: "Opens external website.",
                            newWindowExternal: "Opens external website in a new window."
                        }, e),
                        a = document.createElement("ul"),
                        r = "";
                    for (var o in n) r += "<li id=" + i[o] + ">" + n[o] + "</li>";
                    a.setAttribute("hidden", !0), a.innerHTML = r, t.appendChild(a)
                }(e.messages)
        }
    }, theme.Images = function() {
        return {
            preload: function(e, t) {
                "string" == typeof e && (e = [e]);
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    this.loadImage(this.getSizedImageUrl(n, t))
                }
            },
            loadImage: function(e) {
                (new Image).src = e
            },
            switchImage: function(e, t, i) {
                var n = this.imageSize(t.src),
                    a = this.getSizedImageUrl(e.src, n);
                i ? i(a, e, t) : t.src = a
            },
            imageSize: function(e) {
                var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
                return null !== t ? void 0 !== t[2] ? t[1] + t[2] : t[1] : null
            },
            getSizedImageUrl: function(e, t) {
                if (null === t) return e;
                if ("master" === t) return this.removeProtocol(e);
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null !== i) {
                    var n = e.split(i[0]),
                        a = i[0];
                    return this.removeProtocol(n[0] + "_" + t + a)
                }
                return null
            },
            removeProtocol: function(e) {
                return e.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function() {
        var e = "${{amount}}";
        return {
            formatMoney: function(t, i) {
                "string" == typeof t && (t = t.replace(".", ""));
                var n = "",
                    a = /\{\{\s*(\w+)\s*\}\}/,
                    r = i || e;

                function o(e, t, i, n) {
                    if (i = i || ",", n = n || ".", isNaN(e) || null === e) return 0;
                    var a = (e = (e / 100).toFixed(t)).split(".");
                    return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "")
                }
                switch (r.match(a)[1]) {
                    case "amount":
                        n = o(t, 2);
                        break;
                    case "amount_no_decimals":
                        n = o(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        n = o(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        n = o(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        n = o(t, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        n = o(t, 2, "'")
                }
                return r.replace(a, n)
            }
        }
    }(), slate.Variants = function() {
        function e(e) {
            this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _getCurrentOptions: function() {
                var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
                    var t = $(e),
                        i = t.attr("type"),
                        n = {};
                    return "radio" === i || "checkbox" === i ? !!t[0].checked && (n.value = t.val(), n.index = t.data("index"), n) : (n.value = t.val(), n.index = t.data("index"), n)
                });
                return e = _.compact(e)
            },
            _getVariantFromOptions: function() {
                var e = this._getCurrentOptions(),
                    t = this.product.variants;
                return _.find(t, function(t) {
                    return e.every(function(e) {
                        return _.isEqual(t[e.index], e.value)
                    })
                })
            },
            _onSelectChange: function() {
                var e = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: e
                }), e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), this.currentVariant = e, this.enableHistoryState && this._updateHistoryState(e))
            },
            _updateImages: function(e) {
                var t = e.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                e.featured_image && t.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: e
                })
            },
            _updatePrice: function(e) {
                e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: e
                })
            },
            _updateSKU: function(e) {
                e.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: e
                })
            },
            _updateHistoryState: function(e) {
                if (history.replaceState && e) {
                    var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                    window.history.replaceState({
                        path: t
                    }, "", t)
                }
            },
            _updateMasterSelect: function(e) {
                $(this.originalSelectorId, this.$container).val(e.id)
            }
        }), e
    }(), theme.Drawers = function() {
        function e(e, t, i) {
            var n = {
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + t,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + t
            };
            if (this.nodes = {
                    $parent: $("html").add("body"),
                    $page: $("#PageContainer")
                }, this.config = $.extend(n, i), this.position = t, this.$drawer = $("#" + e), !this.$drawer.length) return !1;
            this.drawerIsOpen = !1, this.init()
        }
        return e.prototype.init = function() {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
        }, e.prototype.open = function(e) {
            var t = !1;
            return e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.drawerIsOpen && !t ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
        }, e.prototype.close = function() {
            this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.unbindEvents(), this.config.onDrawerClose && "function" == typeof this.config.onDrawerClose && this.config.onDrawerClose())
        }, e.prototype.bindEvents = function() {
            this.nodes.$parent.on("keyup.drawer", $.proxy(function(e) {
                return 27 !== e.keyCode || (this.close(), !1)
            }, this)), this.nodes.$page.on("touchmove.drawer", function() {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this))
        }, e.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, e
    }(), window.theme = window.theme || {}, theme.Header = function() {
        var e = {
                body: "body",
                multicurrencySelector: "[data-currency-selector]",
                navigation: "#AccessibleNav",
                siteNavHasDropdown: "[data-has-dropdowns]",
                siteNavChildLinks: ".site-nav__child-link",
                siteNavActiveDropdown: ".site-nav--active-dropdown",
                siteNavHasCenteredDropdown: ".site-nav--has-centered-dropdown",
                siteNavCenteredDropdown: ".site-nav__dropdown--centered",
                siteNavLinkMain: ".site-nav__link--main",
                siteNavChildLink: ".site-nav__link--last",
                siteNavDropdown: ".site-nav__dropdown",
                siteHeader: ".site-header"
            },
            t = {
                activeClass: "site-nav--active-dropdown",
                childLinkClass: "site-nav__child-link",
                rightDropdownClass: "site-nav__dropdown--right",
                leftDropdownClass: "site-nav__dropdown--left"
            },
            i = {};

        function n(n) {
            n.find(e.siteNavLinkMain).attr("aria-expanded", "false"), n.removeClass(t.activeClass), i.$activeDropdown = $(e.siteNavActiveDropdown), $(e.body).off("click.siteNav"), $(window).off("keyup.siteNav")
        }

        function a(n) {
            n.each(function() {
                var n = $(this).find(e.siteNavDropdown);
                n.length && (Math.ceil($(this).offset().left) > Math.floor(i.$siteHeader.outerWidth()) / 2 ? n.removeClass(t.leftDropdownClass).addClass(t.rightDropdownClass) : n.removeClass(t.rightDropdownClass).addClass(t.leftDropdownClass))
            })
        }

        function r() {
            $(e.siteNavHasCenteredDropdown).each(function() {
                var t = $(this),
                    i = t.find(e.siteNavCenteredDropdown),
                    n = t.position().top + 41;
                i.css("top", n)
            })
        }
        return {
            init: function() {
                i = {
                    $nav: $(e.navigation),
                    $topLevel: $(e.siteNavLinkMain),
                    $parents: $(e.navigation).find(e.siteNavHasDropdown),
                    $subMenuLinks: $(e.siteNavChildLinks),
                    $activeDropdown: $(e.siteNavActiveDropdown),
                    $siteHeader: $(e.siteHeader)
                }, a($(e.siteNavHasDropdown)), r(), i.$parents.on("click.siteNav", function() {
                    var a = $(this);
                    a.hasClass(t.activeClass) ? n(a) : function(a) {
                        a.addClass(t.activeClass), i.$activeDropdown.length && n(i.$activeDropdown), i.$activeDropdown = a, a.find(e.siteNavLinkMain).attr("aria-expanded", "true"), setTimeout(function() {
                            $(window).on("keyup.siteNav", function(e) {
                                27 === e.keyCode && n(a)
                            }), $(e.body).on("click.siteNav", function() {
                                n(a)
                            })
                        }, 250)
                    }(a)
                }), $(e.siteNavChildLink).on("focusout.siteNav", function() {
                    setTimeout(function() {
                        !$(document.activeElement).hasClass(t.childLinkClass) && i.$activeDropdown.length && n(i.$activeDropdown)
                    })
                }), i.$topLevel.on("focus.siteNav", function() {
                    i.$activeDropdown.length && n(i.$activeDropdown)
                }), i.$subMenuLinks.on("click.siteNav", function(e) {
                    e.stopImmediatePropagation()
                }), $(e.multicurrencySelector).on("change", function() {
                    $(this).parents("form").submit()
                }), $(window).resize($.debounce(50, function() {
                    a($(e.siteNavHasDropdown)), r()
                }))
            },
            unload: function() {
                $(window).off(".siteNav"), i.$parents.off(".siteNav"), i.$subMenuLinks.off(".siteNav"), i.$topLevel.off(".siteNav"), $(e.siteNavChildLink).off(".siteNav"), $(e.body).off(".siteNav")
            }
        }
    }(), window.theme = window.theme || {}, theme.MobileNav = function() {
        var e, t, i, n = {
                mobileNavOpenIcon: "mobile-nav--open",
                mobileNavCloseIcon: "mobile-nav--close",
                navLinkWrapper: "mobile-nav__item",
                navLink: "mobile-nav__link",
                subNavLink: "mobile-nav__sublist-link",
                return: "mobile-nav__return-btn",
                subNavActive: "is-active",
                subNavClosing: "is-closing",
                navOpen: "js-menu--is-open",
                subNavShowing: "sub-nav--is-open",
                thirdNavShowing: "third-nav--is-open",
                subNavToggleBtn: "js-toggle-submenu"
            },
            a = {},
            r = 1,
            o = "screen and (max-width: 749px)";

        function s() {
            var e;
            a.$mobileNavToggle.hasClass(n.mobileNavCloseIcon) ? c() : (e = a.$siteHeader.outerHeight(), a.$mobileNavContainer.prepareTransition().addClass(n.navOpen), a.$mobileNavContainer.css({
                transform: "translateY(" + e + "px)"
            }), a.$pageContainer.css({
                transform: "translate3d(0, " + a.$mobileNavContainer[0].scrollHeight + "px, 0)"
            }), slate.a11y.trapFocus({
                $container: a.$sectionHeader,
                $elementToFocus: a.$mobileNavToggle,
                namespace: "navFocus"
            }), a.$mobileNavToggle.addClass(n.mobileNavCloseIcon).removeClass(n.mobileNavOpenIcon).attr("aria-expanded", !0), $(window).on("keyup.mobileNav", function(e) {
                27 === e.which && c()
            }))
        }

        function c() {
            a.$mobileNavContainer.prepareTransition().removeClass(n.navOpen), a.$mobileNavContainer.css({
                transform: "translateY(-100%)"
            }), a.$pageContainer.removeAttr("style"), slate.a11y.trapFocus({
                $container: $("html"),
                $elementToFocus: $("body")
            }), a.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function() {
                slate.a11y.removeTrapFocus({
                    $container: a.$mobileNav,
                    namespace: "navFocus"
                })
            }), a.$mobileNavToggle.addClass(n.mobileNavOpenIcon).removeClass(n.mobileNavCloseIcon).attr("aria-expanded", !1).focus(), $(window).off("keyup.mobileNav"), scrollTo(0, 0)
        }

        function l(o) {
            if (!e) {
                var s = $(o.currentTarget),
                    c = s.hasClass(n.return);
                e = !0, c ? ($("." + n.subNavToggleBtn + '[data-level="' + (r - 1) + '"]').removeClass(n.subNavActive), i && i.length && i.removeClass(n.subNavActive)) : s.addClass(n.subNavActive), i = s,
                    function(i) {
                        var o = i ? $('.mobile-nav__dropdown[data-parent="' + i + '"]') : a.$mobileNav;
                        r = o.data("level") ? o.data("level") : 1, t && t.length && t.prepareTransition().addClass(n.subNavClosing);
                        t = o;
                        var s = o.outerHeight(),
                            c = r > 2 ? n.thirdNavShowing : n.subNavShowing;
                        a.$mobileNavContainer.css("height", s).removeClass(n.thirdNavShowing).addClass(c), i || a.$mobileNavContainer.removeClass(n.thirdNavShowing).removeClass(n.subNavShowing);
                        var l = 1 === r ? a.$sectionHeader : o,
                            u = o.find("[data-menu-title=" + r + "]"),
                            d = u || o;
                        a.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function() {
                            slate.a11y.trapFocus({
                                $container: l,
                                $elementToFocus: d,
                                namespace: "subNavFocus"
                            }), a.$mobileNavContainer.off(".subnavToggle"), e = !1
                        }), a.$pageContainer.css({
                            transform: "translateY(" + s + "px)"
                        }), t.removeClass(n.subNavClosing)
                    }(s.data("target"))
            }
        }
        return {
            init: function() {
                (a = {
                    $pageContainer: $("#PageContainer"),
                    $siteHeader: $(".site-header"),
                    $mobileNavToggle: $(".js-mobile-nav-toggle"),
                    $mobileNavContainer: $(".mobile-nav-wrapper"),
                    $mobileNav: $("#MobileNav"),
                    $sectionHeader: $("#shopify-section-header"),
                    $subNavToggleBtn: $("." + n.subNavToggleBtn)
                }).$mobileNavToggle.on("click", s), a.$subNavToggleBtn.on("click.subNav", l), enquire.register(o, {
                    unmatch: function() {
                        a.$mobileNavContainer.hasClass(n.navOpen) && c()
                    }
                })
            },
            closeMobileNav: c
        }
    }(jQuery), window.theme = window.theme || {}, theme.Search = function() {
        var e = {
                search: ".search",
                searchSubmit: ".search__submit",
                searchInput: ".search__input",
                siteHeader: ".site-header",
                siteHeaderSearchToggle: ".site-header__search-toggle",
                siteHeaderSearch: ".site-header__search",
                searchDrawer: ".search-bar",
                searchDrawerInput: ".search-bar__input",
                searchHeader: ".search-header",
                searchHeaderInput: ".search-header__input",
                searchHeaderSubmit: ".search-header__submit",
                searchResultSubmit: "#SearchResultSubmit",
                searchResultInput: "#SearchInput",
                searchResultMessage: "[data-search-error-message]",
                mobileNavWrapper: ".mobile-nav-wrapper"
            },
            t = {
                focus: "search--focus",
                hidden: "hide",
                mobileNavIsOpen: "js-menu--is-open",
                searchTemplate: "template-search"
            };

        function i() {
            n($(e.searchDrawerInput)), $(e.mobileNavWrapper).hasClass(t.mobileNavIsOpen) && theme.MobileNav.closeMobileNav()
        }

        function n(e) {
            e.focus(), e[0].setSelectionRange(0, e[0].value.length)
        }

        function a() {
            $(e.siteHeaderSearchToggle).focus()
        }

        function r(e) {
            0 === this.$searchResultInput.val().trim().length ? (void 0 !== e && e.preventDefault(), n(this.$searchResultInput), function() {
                this.$searchErrorMessage.removeClass(t.hidden), this.$searchResultInput.attr("aria-describedby", "error-search-form").attr("aria-invalid", !0)
            }.call(this)) : function() {
                this.$searchErrorMessage.addClass(t.hidden), this.$searchResultInput.removeAttr("aria-describedby").removeAttr("aria-invalid")
            }.call(this)
        }
        return {
            init: function() {
                $(e.siteHeader).length && (this.$searchResultInput = $(e.searchResultInput), this.$searchErrorMessage = $(e.searchResultMessage), $("#PageContainer").addClass("drawer-page-content"), $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false").attr("aria-haspopup", "dialog"), theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
                    onDrawerOpen: i,
                    onDrawerClose: a
                }), null !== slate.utils.getParameterByName("q") && $("body").hasClass(t.searchTemplate) && r.call(this), $(e.searchResultSubmit).on("click", r.bind(this)), $(e.searchHeaderInput).add(e.searchHeaderSubmit).on("focus blur", function() {
                    $(e.searchHeader).toggleClass(t.focus)
                }), $(e.siteHeaderSearchToggle).on("click", function() {
                    var t = $(e.siteHeader).outerHeight(),
                        i = $(e.siteHeader).offset().top - t;
                    $(e.searchDrawer).css({
                        height: t + "px",
                        top: i + "px"
                    })
                }))
            }
        }
    }(),
    function() {
        var e = $(".return-link");

        function t(e) {
            var t = document.createElement("a");
            return t.ref = e, t.hostname
        }
        document.referrer && e.length && window.history.length && e.one("click", function(e) {
            e.preventDefault();
            var i = t(document.referrer);
            return t(window.location.href) === i && history.back(), !1
        })
    }(), theme.Slideshow = function() {
        this.$slideshow = null;
        var e = {
                slideshow: "slideshow",
                slickActiveMobile: "slick-active-mobile",
                controlsHover: "slideshow__controls--hover",
                isPaused: "is-paused"
            },
            t = {
                section: ".shopify-section",
                wrapper: "#SlideshowWrapper-",
                slides: ".slideshow__slide",
                textWrapperMobile: ".slideshow__text-wrap--mobile",
                textContentMobile: ".slideshow__text-content--mobile",
                controls: ".slideshow__controls",
                pauseButton: ".slideshow__pause",
                dots: ".slick-dots",
                arrows: ".slideshow__arrows",
                arrowsMobile: ".slideshow__arrows--mobile",
                arrowLeft: ".slideshow__arrow-left",
                arrowRight: ".slideshow__arrow-right"
            };

        function i(i, a) {
            var r = this.$slideshow = $(i);
            this.adaptHeight = this.$slideshow.data("adapt-height"), this.$wrapper = this.$slideshow.closest(t.wrapper + a), this.$section = this.$wrapper.closest(t.section), this.$controls = this.$wrapper.find(t.controls), this.$arrows = this.$section.find(t.arrows), this.$arrowsMobile = this.$section.find(t.arrowsMobile), this.$pause = this.$controls.find(t.pauseButton), this.$textWrapperMobile = this.$section.find(t.textWrapperMobile), this.autorotate = this.$slideshow.data("autorotate");
            var o = this.$slideshow.data("speed"),
                s = this.$slideshow.data("slide-nav-a11y");
            this.settings = {
                    accessibility: !0,
                    arrows: !1,
                    dots: !0,
                    fade: !0,
                    draggable: !0,
                    touchThreshold: 20,
                    autoplay: this.autorotate,
                    autoplaySpeed: o,
                    appendDots: this.$arrows,
                    customPaging: function(e, i) {
                        return '<a href="' + t.wrapper + a + '" aria-label="' + s.replace("[slide_number]", i + 1) + '" data-slide-number="' + i + '"></a>'
                    }
                }, this.$slideshow.on("beforeChange", function(t, i, n, a) {
                    var r = this.$dots.find("a"),
                        o = this.$mobileDots.find("li");
                    r.removeAttr("aria-current").eq(a).attr("aria-current", "true"), o.removeClass(e.slickActiveMobile).eq(a).addClass(e.slickActiveMobile), this.showMobileText(a)
                }.bind(this)), this.$slideshow.on("init", function(i, a) {
                    var r = a.$slider,
                        o = a.$list;
                    this.$dots = this.$section.find(t.dots), this.$mobileDots = this.$dots.eq(1), o.removeAttr("aria-live"), this.$wrapper.on("keyup", n.bind(this)), this.$controls.on("keyup", n.bind(this)), this.$textWrapperMobile.on("keyup", n.bind(this)), this.$wrapper.on("focusin", function(e) {
                        this.$wrapper.has(e.target).length && (o.attr("aria-live", "polite"), this.autorotate && r.slick("slickPause"))
                    }.bind(this)).on("focusout", function(e) {
                        this.$wrapper.has(e.target).length && (o.removeAttr("aria-live"), this.autorotate && (this.$pause.is(".is-paused") || r.slick("slickPlay")))
                    }.bind(this)), this.$dots && this.$dots.find("a").each(function() {
                        var e = $(this);
                        e.on("click keyup", function(e) {
                            if ("keyup" !== e.type || e.which === slate.utils.keyboardKeys.ENTER) {
                                e.preventDefault();
                                var t = $(e.target).data("slide-number");
                                r.attr("tabindex", -1).slick("slickGoTo", t), "keyup" === e.type && r.focus()
                            }
                        })
                    }).eq(0).attr("aria-current", "true");
                    this.$controls.on("focusin", function() {
                        this.$controls.addClass(e.controlsHover)
                    }.bind(this)).on("focusout", function() {
                        this.$controls.removeClass(e.controlsHover)
                    }.bind(this))
                }.bind(this)), this.$slideshow.on("init", function() {
                    this.$mobileDots.find("li:first-of-type").addClass(e.slickActiveMobile), this.showMobileText(0)
                }.bind(this)), this.autorotate && $(document).scroll($.debounce(250, function() {
                    this.$arrowsMobile.offset().top + this.$arrowsMobile.outerHeight() < window.pageYOffset ? r.slick("slickPause") : this.$pause.hasClass(e.isPaused) || r.slick("slickPlay")
                }.bind(this))), this.adaptHeight && (this.setSlideshowHeight(), $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)))), this.$slideshow.slick(this.settings),
                function() {
                    this.$slideshow.find(t.slides).removeAttr("role").removeAttr("aria-labelledby"), this.$dots.removeAttr("role").find("li").removeAttr("role").removeAttr("aria-selected").each(function() {
                        var e = $(this),
                            t = e.attr("aria-controls");
                        e.removeAttr("aria-controls").find("a").attr("aria-controls", t)
                    })
                }.bind(this)(), this.$arrows.find(t.arrowLeft).on("click", function() {
                    r.slick("slickPrev")
                }), this.$arrows.find(t.arrowRight).on("click", function() {
                    r.slick("slickNext")
                }), this.$pause.on("click", this.togglePause.bind(this))
        }

        function n() {
            event.keyCode === slate.utils.keyboardKeys.LEFTARROW && this.$slideshow.slick("slickPrev"), event.keyCode === slate.utils.keyboardKeys.RIGHTARROW && this.$slideshow.slick("slickNext")
        }
        return i.prototype.togglePause = function() {
            var t = "#Slideshow-" + this.$pause.data("id");
            this.$pause.hasClass(e.isPaused) ? (this.$pause.removeClass(e.isPaused).attr("aria-pressed", "false"), this.autorotate && $(t).slick("slickPlay")) : (this.$pause.addClass(e.isPaused).attr("aria-pressed", "true"), this.autorotate && $(t).slick("slickPause"))
        }, i.prototype.setSlideshowHeight = function() {
            var e = this.$slideshow.data("min-aspect-ratio");
            this.$slideshow.height($(document).width() / e)
        }, i.prototype.showMobileText = function(e) {
            var i = this.$textWrapperMobile.find(t.textContentMobile),
                n = t.textContentMobile + "-" + e,
                a = this.$textWrapperMobile.find(n);
            a.length || 1 !== this.$slideshow.find(t.slides).length ? this.$textWrapperMobile.show() : this.$textWrapperMobile.hide(), i.hide(), a.show()
        }, i
    }(), theme.Video = function() {
        var e = !1,
            t = !1,
            i = !1,
            n = !1,
            a = {},
            r = [],
            o = {
                ratio: 16 / 9,
                scrollAnimationDuration: 400,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    controls: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0,
                    rel: 0
                },
                events: {
                    onReady: function(e) {
                        e.target.setPlaybackQuality("hd1080");
                        var t = g(e);
                        p(), $("#" + t.id).attr("tabindex", "-1"), w(), "background" === t.type && (e.target.mute(), d(t.id));
                        t.$videoWrapper.addClass(s.loaded)
                    },
                    onStateChange: function(t) {
                        var i = g(t);
                        "background" !== i.status || C() || e || t.data !== YT.PlayerState.PLAYING && t.data !== YT.PlayerState.BUFFERING || (h(!0), e = !0, i.$videoWrapper.removeClass(s.loading));
                        switch (t.data) {
                            case YT.PlayerState.ENDED:
                                ! function(e) {
                                    switch (e.type) {
                                        case "background":
                                            r[e.id].seekTo(0);
                                            break;
                                        case "image_with_play":
                                            v(e.id), y(e.id, !1)
                                    }
                                }(i);
                                break;
                            case YT.PlayerState.PAUSED:
                                setTimeout(function() {
                                    t.target.getPlayerState() === YT.PlayerState.PAUSED && m(i)
                                }, 200)
                        }
                    }
                }
            },
            s = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                backgroundVideoWrapper: "video-background-wrapper",
                videoWithImage: "video--image_with_play",
                backgroundVideo: "video--background",
                userPaused: "is-paused",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay",
                wrapperMinHeight: "video-section-wrapper--min-height"
            },
            c = {
                section: ".video-section",
                videoWrapper: ".video-section-wrapper",
                playVideoBtn: ".video-control__play",
                closeVideoBtn: ".video-control__close-wrapper",
                pauseVideoBtn: ".video__pause"
            };

        function l(e) {
            (t || i) && e && "function" == typeof r[e].playVideo && d(e)
        }

        function u(e) {
            r[e] && "function" == typeof r[e].pauseVideo && r[e].pauseVideo()
        }

        function d(t, n) {
            var o = a[t],
                c = r[t],
                l = o.$videoWrapper;
            if (i) f(o);
            else {
                if (n || e) return l.removeClass(s.loading), f(o), void c.playVideo();
                c.playVideo()
            }
        }

        function h(t) {
            var n = t ? s.supportsAutoplay : s.supportsNoAutoplay;
            $(document.documentElement).removeClass(s.supportsAutoplay).removeClass(s.supportsNoAutoplay).addClass(n), t || (i = !0), e = !0
        }

        function p() {
            t || (C() && (i = !0), i && h(!1), t = !0)
        }

        function f(e) {
            var t = e.$videoWrapper,
                i = t.find(c.pauseVideoBtn);
            t.removeClass(s.loading), i.hasClass(s.userPaused) && i.removeClass(s.userPaused), "background" !== e.status && ($("#" + e.id).attr("tabindex", "0"), "image_with_play" === e.type && t.removeClass(s.paused).addClass(s.playing), setTimeout(function() {
                t.find(c.closeVideoBtn).focus()
            }, o.scrollAnimationDuration))
        }

        function m(e) {
            var t = e.$videoWrapper;
            "image_with_play" === e.type && ("closed" === e.status ? t.removeClass(s.paused) : t.addClass(s.paused)), t.removeClass(s.playing)
        }

        function v(e) {
            var t = a[e],
                i = t.$videoWrapper,
                n = [s.paused, s.playing].join(" ");
            switch (C() && i.removeAttr("style"), $("#" + t.id).attr("tabindex", "-1"), t.status = "closed", t.type) {
                case "image_with_play":
                    r[e].stopVideo(), m(t);
                    break;
                case "background":
                    r[e].mute(),
                        function(e) {
                            $("#" + e).removeClass(s.videoWithImage).addClass(s.backgroundVideo), a[e].$videoWrapper.addClass(s.backgroundVideoWrapper), a[e].status = "background", _($("#" + e))
                        }(e)
            }
            i.removeClass(n)
        }

        function g(e) {
            return a[e.target.a.id]
        }

        function y(e, t) {
            var i = a[e],
                n = i.$videoWrapper.offset().top,
                r = i.$videoWrapper.find(c.playVideoBtn),
                l = 0,
                u = 0;
            C() && i.$videoWrapper.parent().toggleClass("page-width", !t), t ? (u = C() ? $(window).width() / o.ratio : i.$videoWrapper.width() / o.ratio, l = ($(window).height() - u) / 2, i.$videoWrapper.removeClass(s.wrapperMinHeight).animate({
                height: u
            }, 600), C() && Shopify.designMode || $("html, body").animate({
                scrollTop: n - l
            }, o.scrollAnimationDuration)) : (u = C() ? i.$videoWrapper.data("mobile-height") : i.$videoWrapper.data("desktop-height"), i.$videoWrapper.height(i.$videoWrapper.width() / o.ratio).animate({
                height: u
            }, 600), setTimeout(function() {
                i.$videoWrapper.addClass(s.wrapperMinHeight)
            }, 600), r.focus())
        }

        function b(e) {
            var t = a[e];
            switch (t.$videoWrapper.addClass(s.loading), t.$videoWrapper.attr("style", "height: " + t.$videoWrapper.height() + "px"), t.status = "open", t.type) {
                case "image_with_play":
                    d(e, !0);
                    break;
                case "background":
                    ! function(e) {
                        $("#" + e).removeClass(s.backgroundVideo).addClass(s.videoWithImage), setTimeout(function() {
                            $("#" + e).removeAttr("style")
                        }, 600), a[e].$videoWrapper.removeClass(s.backgroundVideoWrapper).addClass(s.playing), a[e].status = "open"
                    }(e), r[e].unMute(), d(e, !0)
            }
            y(e, !0), $(document).on("keydown.videoPlayer", function(e) {
                var t = $(document.activeElement).data("controls");
                e.keyCode === slate.utils.keyboardKeys.ESCAPE && t && (v(t), y(t, !1))
            })
        }

        function w() {
            $("." + s.backgroundVideo).each(function(e, t) {
                _($(t))
            })
        }

        function _(e) {
            if (n)
                if (C()) e.removeAttr("style");
                else {
                    var t = e.closest(c.videoWrapper),
                        i = t.width(),
                        a = e.width(),
                        r = t.data("desktop-height");
                    i / o.ratio < r ? (a = Math.ceil(r * o.ratio), e.width(a).height(r).css({
                        left: (i - a) / 2,
                        top: 0
                    })) : (r = Math.ceil(i / o.ratio), e.width(i).height(r).css({
                        left: 0,
                        top: (r - r) / 2
                    })), e.prepareTransition(), t.addClass(s.loaded)
                }
        }

        function C() {
            return $(window).width() < 750 || window.mobileCheck()
        }

        function k() {
            $(document).on("click.videoPlayer", c.playVideoBtn, function(e) {
                b($(e.currentTarget).data("controls"))
            }), $(document).on("click.videoPlayer", c.closeVideoBtn, function(e) {
                var t = $(e.currentTarget).data("controls");
                $(e.currentTarget).blur(), v(t), y(t, !1)
            }), $(document).on("click.videoPlayer", c.pauseVideoBtn, function(e) {
                ! function(e) {
                    var t = a[e].$videoWrapper.find(c.pauseVideoBtn),
                        i = t.hasClass(s.userPaused);
                    i ? (t.removeClass(s.userPaused), l(e)) : (t.addClass(s.userPaused), u(e)), t.attr("aria-pressed", !i)
                }($(e.currentTarget).data("controls"))
            }), $(window).on("resize.videoPlayer", $.debounce(200, function() {
                if (n) {
                    var e, t = window.innerHeight === screen.height;
                    if (w(), C()) {
                        for (e in a) a.hasOwnProperty(e) && (a[e].$videoWrapper.hasClass(s.playing) && (t || (u(e), m(a[e]))), a[e].$videoWrapper.height($(document).width() / o.ratio));
                        h(!1)
                    } else
                        for (e in h(!0), a) a[e].$videoWrapper.find("." + s.videoWithImage).length || (r[e].playVideo(), f(a[e]))
                }
            })), $(window).on("scroll.videoPlayer", $.debounce(50, function() {
                if (n)
                    for (var e in a)
                        if (a.hasOwnProperty(e)) {
                            var t = a[e].$videoWrapper;
                            t.hasClass(s.playing) && (t.offset().top + .75 * t.height() < $(window).scrollTop() || t.offset().top + .25 * t.height() > $(window).scrollTop() + $(window).height()) && (v(e), y(e, !1))
                        }
            }))
        }

        function S(e) {
            var t = $.extend({}, o, a[e]);
            t.playerVars.controls = t.controls, r[e] = new YT.Player(e, t)
        }
        return {
            init: function(e) {
                if (e.length) {
                    if (a[e.attr("id")] = {
                            id: e.attr("id"),
                            videoId: e.data("id"),
                            type: e.data("type"),
                            status: "image_with_play" === e.data("type") ? "closed" : "background",
                            $video: e,
                            $videoWrapper: e.closest(c.videoWrapper),
                            $section: e.closest(c.section),
                            controls: "background" === e.data("type") ? 0 : 1
                        }, !n) {
                        var t = document.createElement("script");
                        t.src = "https://www.youtube.com/iframe_api";
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(t, i)
                    }
                    p()
                }
            },
            editorLoadVideo: function(e) {
                n && (S(e), k())
            },
            loadVideos: function() {
                for (var e in a) a.hasOwnProperty(e) && S(e);
                k(), n = !0
            },
            playVideo: l,
            pauseVideo: u,
            removeEvents: function() {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer")
            }
        }
    }(), window.theme = window.theme || {}, theme.FormStatus = function() {
        var e = {
            statusMessage: "[data-form-status]"
        };
        return {
            init: function() {
                this.$statusMessage = $(e.statusMessage), this.$statusMessage && (this.$statusMessage.attr("tabindex", -1).focus(), this.$statusMessage.on("blur", function() {
                    this.$statusMessage.removeAttr("tabindex")
                }.bind(this)))
            }
        }
    }(), theme.Hero = function() {
        var e = {
                indexSectionFlush: "index-section--flush"
            },
            t = {
                heroFixedWidthContent: ".hero-fixed-width__content",
                heroFixedWidthImage: ".hero-fixed-width__image"
            };
        return function(i, n) {
            this.$hero = $(i), this.layout = this.$hero.data("layout");
            var a = $("#shopify-section-" + n),
                r = a.find(t.heroFixedWidthContent),
                o = a.find(t.heroFixedWidthImage);

            function s() {
                var e = r.height() + 50;
                e > o.height() && o.css("min-height", e)
            }
            "fixed_width" === this.layout && (a.removeClass(e.indexSectionFlush), s(), $(window).resize($.debounce(50, function() {
                s()
            })))
        }
    }(),
    function() {
        var e = $("#BlogTagFilter");
        e.length && e.on("change", function() {
            location.href = $(this).val()
        })
    }(), window.theme = theme || {}, theme.customerTemplates = function() {
        var e = {
            RecoverHeading: "#RecoverHeading",
            RecoverEmail: "#RecoverEmail",
            LoginHeading: "#LoginHeading"
        };

        function t() {
            this.$RecoverHeading = $(e.RecoverHeading), this.$RecoverEmail = $(e.RecoverEmail), this.$LoginHeading = $(e.LoginHeading), $("#RecoverPassword, #RecoverPasswordHere").on("click", function(e) {
                e.preventDefault(), i(), this.$RecoverHeading.attr("tabindex", "-1").focus()
            }.bind(this)), $("#HideRecoverPasswordLink").on("click", function(e) {
                e.preventDefault(), $("#RecoverPasswordForm").addClass("hide"), $("#CustomerLoginForm").removeClass("hide"), this.$LoginHeading.attr("tabindex", "-1").focus()
            }.bind(this)), this.$RecoverHeading.on("blur", function() {
                $(this).removeAttr("tabindex")
            }), this.$LoginHeading.on("blur", function() {
                $(this).removeAttr("tabindex")
            })
        }

        function i() {
            $("#RecoverPasswordForm").removeClass("hide"), $("#CustomerLoginForm").addClass("hide"), "true" === this.$RecoverEmail.attr("aria-invalid") && this.$RecoverEmail.focus()
        }
        return {
            init: function() {
                var e, n;
                t(),
                    function() {
                        "#recover" === window.location.hash && i.bind(this)()
                    }(), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide").focus(), e = $("#AddressNewForm"), n = $("#AddressNewButton"), e.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                        hideElement: "AddressProvinceContainerNew"
                    }), $(".address-country-option").each(function() {
                        var e = $(this).data("form-id"),
                            t = "AddressCountry_" + e,
                            i = "AddressProvince_" + e,
                            n = "AddressProvinceContainer_" + e;
                        new Shopify.CountryProvinceSelector(t, i, {
                            hideElement: n
                        })
                    }), $(".address-new-toggle").on("click", function() {
                        var t = "true" === n.attr("aria-expanded");
                        e.toggleClass("hide"), n.attr("aria-expanded", !t).focus()
                    }), $(".address-edit-toggle").on("click", function() {
                        var e = $(this).data("form-id"),
                            t = $("#EditFormButton_" + e),
                            i = $("#EditAddress_" + e),
                            n = "true" === t.attr("aria-expanded");
                        i.toggleClass("hide"), t.attr("aria-expanded", !n).focus()
                    }), $(".address-delete").on("click", function() {
                        var e = $(this),
                            t = e.data("target"),
                            i = e.data("confirm-message");
                        confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink(t, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
            }
        }
    }(), window.theme = window.theme || {}, theme.Cart = function() {
        var e = {
                edit: ".js-edit-toggle",
                inputQty: ".cart__qty-input",
                thumbnails: ".cart__image",
                item: ".cart__row"
            },
            t = {
                showClass: "cart__update--show",
                showEditClass: "cart__edit--active",
                cartNoCookies: "cart--no-cookies"
            };

        function i(i) {
            this.$container = $(i), this.$edit = $(e.edit, this.$container), this.$inputQuantities = $(e.inputQty, this.$container), this.$thumbnails = $(e.thumbnails, this.$container), this.cookiesEnabled() || this.$container.addClass(t.cartNoCookies), this.$edit.on("click", this._onEditClick), this.$inputQuantities.on("change", this._handleInputQty), this.$thumbnails.css("cursor", "pointer"), this.$thumbnails.on("click", this._handleThumbnailClick)
        }
        return i.prototype = _.assignIn({}, i.prototype, {
            onUnload: function() {
                this.$edit.off("click", this._onEditClick)
            },
            _onEditClick: function(e) {
                var i = $(e.target),
                    n = $("." + i.data("target")),
                    a = "true" === i.attr("aria-expanded");
                i.toggleClass(t.showEditClass).attr("aria-expanded", !a), n.toggleClass(t.showClass)
            },
            _handleInputQty: function(e) {
                var t = $(e.target),
                    i = t.val(),
                    n = t.data("quantity-item");
                $("[data-quantity-item=" + n + "]").val(i)
            },
            _handleThumbnailClick: function(e) {
                var t = $(e.target).data("item-url");
                window.location.href = t
            },
            cookiesEnabled: function() {
                var e = navigator.cookieEnabled;
                return e || (document.cookie = "testcookie", e = -1 !== document.cookie.indexOf("testcookie")), e
            }
        }), i
    }(), window.theme = window.theme || {}, theme.Filters = function() {
        var e = "screen and (min-width: 750px)",
            t = "sort_by",
            i = {
                mainContent: "#MainContent",
                filterSelection: "#FilterTags",
                sortSelection: "#SortBy"
            },
            n = "data-default-sortby";

        function a(e) {
            var t = this.$container = $(e);
            this.$filterSelect = $(i.filterSelection, t), this.$sortSelect = $(i.sortSelection, t), this.$selects = $(i.filterSelection, t).add($(i.sortSelection, t)), this.defaultSort = this._getDefaultSortValue(), this.$selects.removeClass("hidden"), this.$filterSelect.on("change", this._onFilterChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this)), this._initBreakpoints()
        }
        return a.prototype = _.assignIn({}, a.prototype, {
            _initBreakpoints: function() {
                var t = this;
                enquire.register(e, {
                    match: function() {
                        t._resizeSelect(t.$selects)
                    }
                })
            },
            _onSortChange: function() {
                var e = this._sortValue(),
                    t = window.location.href.replace(window.location.search, ""),
                    i = slate.utils.getParameterByName("q"),
                    n = slate.utils.getParameterByName("limit"),
                    a = null !== i ? i : "";
                if (e.length) {
                    var r = t.replace(window.location.hash, "");
                    a = "" !== a ? "?q=" + a + "&" : "?", slate.utils.getParameterByName("limit") ? window.location.href = r + a + e + "&limit=" + n : window.location.href = r + a + e
                } else window.location.href = t
            },
            _onFilterChange: function() {
                var e = this._getFilterValue(),
                    t = document.location.search.replace(/\?(page=\w+)?&?/, "");
                t = "" !== t ? "?" + t : "", document.location.href = e + t
            },
            _getFilterValue: function() {
                return this.$filterSelect.val()
            },
            _getSortValue: function() {
                return this.$sortSelect.val() || this.defaultSort
            },
            _getDefaultSortValue: function() {
                return this.$sortSelect.attr(n)
            },
            _sortValue: function() {
                var e = this._getSortValue(),
                    i = "";
                return e !== this.defaultSort && (i = t + "=" + e), i
            },
            _resizeSelect: function(e) {
                e.each(function() {
                    var e = $(this),
                        t = e.find("option:selected").text(),
                        i = $("<span>").html(t);
                    i.appendTo("body");
                    var n = i.width();
                    i.remove(), e.width(n + 10)
                })
            },
            onUnload: function() {
                this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange)
            }
        }), a
    }(), window.theme = window.theme || {}, theme.HeaderSection = function() {
        function e() {
            theme.Header.init(), theme.MobileNav.init(), theme.Search.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            onUnload: function() {
                theme.Header.unload()
            }
        }), e
    }(), theme.Maps = function() {
        var e = 14,
            t = null,
            i = [],
            n = {
                addressNoResults: theme.strings.addressNoResults,
                addressQueryLimit: theme.strings.addressQueryLimit,
                addressError: theme.strings.addressError,
                authError: theme.strings.authError
            },
            a = {
                section: '[data-section-type="map"]',
                map: "[data-map]",
                mapOverlay: "[data-map-overlay]"
            },
            r = "map-section--load-error",
            o = "map-section__error errors text-center";

        function s(e) {
            this.$container = $(e), this.$map = this.$container.find(a.map), this.key = this.$map.data("api-key"), void 0 !== this.key && ("loaded" === t ? this.createMap() : (i.push(this), "loading" !== t && (t = "loading", void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function() {
                t = "loaded", $.each(i, function(e, t) {
                    t.createMap()
                })
            }))))
        }
        return window.gm_authFailure = function() {
            Shopify.designMode && ($(a.section).addClass(r), $(a.map).remove(), $(a.mapOverlay).after('<div class="' + o + '">' + theme.strings.authError + "</div>"))
        }, s.prototype = _.assignIn({}, s.prototype, {
            createMap: function() {
                var t = this.$map;
                return function(e) {
                    var t = $.Deferred(),
                        i = new google.maps.Geocoder,
                        n = e.data("address-setting");
                    return i.geocode({
                        address: n
                    }, function(e, i) {
                        i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e)
                    }), t
                }(t).then(function(i) {
                    var n = {
                            zoom: e,
                            center: i[0].geometry.location,
                            draggable: !1,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !0
                        },
                        a = this.map = new google.maps.Map(t[0], n),
                        r = this.center = a.getCenter();
                    new google.maps.Marker({
                        map: a,
                        position: a.getCenter()
                    });
                    google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                        google.maps.event.trigger(a, "resize"), a.setCenter(r), t.removeAttr("style")
                    }))
                }.bind(this)).fail(function() {
                    var e;
                    switch (status) {
                        case "ZERO_RESULTS":
                            e = n.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            e = n.addressQueryLimit;
                            break;
                        case "REQUEST_DENIED":
                            e = n.authError;
                            break;
                        default:
                            e = n.addressError
                    }
                    Shopify.designMode && t.parent().addClass(r).html('<div class="' + o + '">' + e + "</div>")
                })
            },
            onUnload: function() {
                0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize")
            }
        }), s
    }(), theme.Product = function() {
        function e(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 750px)",
                mediaQuerySmall: "screen and (max-width: 749px)",
                bpSmall: !1,
                enableHistoryState: t.data("enable-history-state") || !1,
                namespace: ".slideshow-" + i,
                sectionId: i,
                sliderActive: !1,
                zoomEnabled: !1
            }, this.selectors = {
                addToCart: "[data-add-to-cart]",
                addToCartText: "[data-add-to-cart-text]",
                cartCount: "[data-cart-count]",
                cartCountBubble: "[data-cart-count-bubble]",
                cartPopup: "[data-cart-popup]",
                cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
                cartPopupClose: "[data-cart-popup-close]",
                cartPopupDismiss: "[data-cart-popup-dismiss]",
                cartPopupImage: "[data-cart-popup-image]",
                cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
                cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
                cartPopupProductDetails: "[data-cart-popup-product-details]",
                cartPopupQuantity: "[data-cart-popup-quantity]",
                cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
                cartPopupTitle: "[data-cart-popup-title]",
                cartPopupWrapper: "[data-cart-popup-wrapper]",
                loader: "[data-loader]",
                loaderStatus: "[data-loader-status]",
                quantity: "[data-quantity-input]",
                SKU: ".variant-sku",
                productStatus: "[data-product-status]",
                originalSelectorId: "#ProductSelect-" + i,
                productForm: "[data-product-form]",
                errorMessage: "[data-error-message]",
                errorMessageWrapper: "[data-error-message-wrapper]",
                productImageWraps: ".product-single__photo",
                productThumbImages: ".product-single__thumbnail--" + i,
                productThumbs: ".product-single__thumbnails-" + i,
                productThumbListItem: ".product-single__thumbnails-item",
                productFeaturedImage: ".product-featured-img",
                productThumbsWrapper: ".thumbnails-wrapper",
                saleLabel: ".product-price__sale-label-" + i,
                singleOptionSelector: ".single-option-selector-" + i,
                shopifyPaymentButton: ".shopify-payment-button",
                priceContainer: "[data-price]",
                regularPrice: "[data-regular-price]",
                salePrice: "[data-sale-price]",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]"
            }, this.classes = {
                cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
                hidden: "hide",
                inputError: "input--error",
                productOnSale: "price--on-sale",
                productUnitAvailable: "price--unit-available",
                productUnavailable: "price--unavailable",
                productFormErrorMessageWrapperHidden: "product-form__error-message-wrapper--hidden",
                activeClass: "active-thumb"
            }, this.$quantityInput = $(this.selectors.quantity, t), this.$errorMessageWrapper = $(this.selectors.errorMessageWrapper, t), this.$addToCart = $(this.selectors.addToCart, t), this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart), this.$loader = $(this.selectors.loader, this.$addToCart), this.$loaderStatus = $(this.selectors.loaderStatus, t), this.$shopifyPaymentButton = $(this.selectors.shopifyPaymentButton, t), $("#ProductJson-" + i).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass("js-zoom-enabled"), this._initBreakpoints(), this._stringOverrides(), this._initVariants(), this._initImageSwitch(), this._initAddToCart(), this._setActiveThumbnail())
        }
        return $(".selector-wrapper").hide(), e.prototype = _.assignIn({}, e.prototype, {
            _stringOverrides: function() {
                theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
            },
            _initBreakpoints: function() {
                var e = this;
                enquire.register(this.settings.mediaQuerySmall, {
                    match: function() {
                        $(e.selectors.productThumbImages).length > 3 && e._initThumbnailSlider(), e.settings.zoomEnabled && $(e.selectors.productImageWraps).each(function() {
                            $(this).trigger("zoom.destroy")
                        }), e.settings.bpSmall = !0
                    },
                    unmatch: function() {
                        e.settings.sliderActive && e._destroyThumbnailSlider(), e.settings.bpSmall = !1
                    }
                }), enquire.register(this.settings.mediaQueryMediumUp, {
                    match: function() {
                        e.settings.zoomEnabled && $(e.selectors.productImageWraps).each(function() {
                            var e, t;
                            e = this, t = $(e).data("zoom"), $(e).zoom({
                                url: t
                            })
                        })
                    }
                })
            },
            _initVariants: function() {
                var e = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAvailability.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
            },
            _initImageSwitch: function() {
                if ($(this.selectors.productThumbImages).length) {
                    var e = this;
                    $(this.selectors.productThumbImages).on("click", function(t) {
                        t.preventDefault();
                        var i = $(this).data("thumbnail-id");
                        e._switchImage(i), e._setActiveThumbnail(i)
                    }).on("keyup", e._handleImageFocus.bind(e))
                }
            },
            _initAddToCart: function() {},
            _addItemToCart: function(e) {
                var t = {
                    url: "/cart/add.js",
                    data: $(e).serialize(),
                    dataType: "json"
                };
                $.post(t).done(function(e) {
                    this._hideErrorMessage(), this._setupCartPopup(e)
                }.bind(this)).fail(function(e) {
                    this.$previouslyFocusedElement.focus(), this._showErrorMessage(e.responseJSON.description), this._handleButtonLoadingState(!1)
                }.bind(this))
            },
            _handleButtonLoadingState: function(e) {
                e ? (this.$addToCart.attr("aria-disabled", !0), this.$addToCartText.addClass(this.classes.hidden), this.$loader.removeClass(this.classes.hidden), this.$shopifyPaymentButton.attr("disabled", !0), this.$loaderStatus.attr("aria-hidden", !1)) : (this.$addToCart.removeAttr("aria-disabled"), this.$addToCartText.removeClass(this.classes.hidden), this.$loader.addClass(this.classes.hidden), this.$shopifyPaymentButton.removeAttr("disabled"), this.$loaderStatus.attr("aria-hidden", !0))
            },
            _showErrorMessage: function(e) {
                $(this.selectors.errorMessage, this.$container).html(e), 0 !== this.$quantityInput.length && this.$quantityInput.addClass(this.classes.inputError), this.$errorMessageWrapper.removeClass(this.classes.productFormErrorMessageWrapperHidden).attr("aria-hidden", !0).removeAttr("aria-hidden")
            },
            _hideErrorMessage: function() {
                this.$errorMessageWrapper.addClass(this.classes.productFormErrorMessageWrapperHidden), 0 !== this.$quantityInput.length && this.$quantityInput.removeClass(this.classes.inputError)
            },
            _setupCartPopup: function(e) {
                this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup), this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper), this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle), this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity), this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel), this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose), this.$cartPopupDismiss = this.cartPopupDismiss || $(this.selectors.cartPopupDismiss), this._setupCartPopupEventListeners(), this._updateCartPopupContent(e)
            },
            _updateCartPopupContent: function(e) {
                var t = this.$quantityInput.length ? this.$quantityInput.val() : 1;
                this.$cartPopupTitle.text(e.product_title), this.$cartPopupQuantity.text(t), this.$cartPopupQuantityLabel.text(theme.strings.quantityLabel.replace("[count]", t)), this._setCartPopupImage(e.image, e.title), this._setCartPopupProductDetails(e.variant_options, e.properties), $.getJSON("/cart.js").then(function(e) {
                    this._setCartQuantity(e.item_count), this._setCartCountBubble(e.item_count), this._showCartPopup()
                }.bind(this))
            },
            _setupCartPopupEventListeners: function() {
                this.$cartPopupWrapper.on("keyup", function(e) {
                    e.keyCode === slate.utils.keyboardKeys.ESCAPE && this._hideCartPopup(e)
                }.bind(this)), this.$cartPopupClose.on("click", this._hideCartPopup.bind(this)), this.$cartPopupDismiss.on("click", this._hideCartPopup.bind(this)), $("body").on("click", this._onBodyClick.bind(this))
            },
            _setCartPopupImage: function(e, t) {
                if (this.$cartPopupImageWrapper = this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper), this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder), null !== e) {
                    this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
                    var i = theme.Images.getSizedImageUrl(e, "200x"),
                        n = document.createElement("img");
                    n.src = i, n.alt = t, n.dataset.cartPopupImage = "", n.onload = function() {
                        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden), this.$cartPopupImageWrapper.append(n)
                    }.bind(this)
                } else this.$cartPopupImageWrapper.addClass(this.classes.hidden)
            },
            _setCartPopupProductDetails: function(e, t) {
                this.$cartPopupProductDetails = this.$cartPopupProductDetails || $(this.selectors.cartPopupProductDetails);
                var i = "";
                "Default Title" !== e[0] && (i += this._getVariantOptionList(e)), null !== t && 0 !== Object.keys(t).length && (i += this._getPropertyList(t)), 0 === i.length ? (this.$cartPopupProductDetails.html(""), this.$cartPopupProductDetails.attr("hidden", "")) : (this.$cartPopupProductDetails.html(i), this.$cartPopupProductDetails.removeAttr("hidden"))
            },
            _getVariantOptionList: function(e) {
                var t = "";
                return e.forEach(function(e) {
                    t = t + '<li class="product-details__item product-details__item--variant-option">' + e + "</li>"
                }), t
            },
            _getPropertyList: function(e) {
                var t = "";
                return Object.entries(e).forEach(function(e) {
                    "_" !== e[0].charAt(0) && 0 !== e[1].length && (t = t + '<li class="product-details__item product-details__item--property"><span class="product-details__property-label">' + e[0] + ": </span>" + e[1])
                }), t
            },
            _setCartQuantity: function(e) {
                var t;
                this.$cartPopupCartQuantity = this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity), 1 === e ? t = theme.strings.oneCartCount : e > 1 && (t = theme.strings.otherCartCount.replace("[count]", e)), this.$cartPopupCartQuantity.text(e).attr("aria-label", t)
            },
            _setCartCountBubble: function(e) {
                this.$cartCountBubble = this.$cartCountBubble || $(this.selectors.cartCountBubble), this.$cartCount = this.$cartCount || $(this.selectors.cartCount), this.$cartCountBubble.removeClass(this.classes.hidden), this.$cartCount.text(e)
            },
            _showCartPopup: function() {
                this.$cartPopupWrapper.prepareTransition().removeClass(this.classes.cartPopupWrapperHidden), this._handleButtonLoadingState(!1), slate.a11y.trapFocus({
                    $container: this.$cartPopupWrapper,
                    $elementToFocus: this.$cartPopup,
                    namespace: "cartPopupFocus"
                })
            },
            _hideCartPopup: function(e) {
                var t = 0 === e.detail;
                this.$cartPopupWrapper.prepareTransition().addClass(this.classes.cartPopupWrapperHidden), $(this.selectors.cartPopupImage).remove(), this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden), slate.a11y.removeTrapFocus({
                    $container: this.$cartPopupWrapper,
                    namespace: "cartPopupFocus"
                }), t && this.$previouslyFocusedElement[0].focus(), this.$cartPopupWrapper.off("keyup"), this.$cartPopupClose.off("click"), this.$cartPopupDismiss.off("click"), $("body").off("click")
            },
            _onBodyClick: function(e) {
                var t = $(e.target);
                t[0] === this.$cartPopupWrapper[0] || t.parents(this.selectors.cartPopup).length || this._hideCartPopup(e)
            },
            _setActiveThumbnail: function(e) {
                void 0 === e && (e = $(this.selectors.productImageWraps + ":not(.hide)", this.$container).data("image-id"));
                var t = $(this.selectors.productThumbListItem + ":not(.slick-cloned)", this.$container),
                    i = t.find(this.selectors.productThumbImages + "[data-thumbnail-id='" + e + "']");
                if ($(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr("aria-current"), i.addClass(this.classes.activeClass), i.attr("aria-current", !0), t.hasClass("slick-slide")) {
                    var n = i.parent().data("slick-index");
                    $(this.selectors.productThumbs).slick("slickGoTo", n, !0)
                }
            },
            _switchImage: function(e) {
                var t = $(this.selectors.productImageWraps + "[data-image-id='" + e + "']", this.$container),
                    i = $(this.selectors.productImageWraps + ":not([data-image-id='" + e + "'])", this.$container);
                t.removeClass(this.classes.hidden), i.addClass(this.classes.hidden)
            },
            _handleImageFocus: function(e) {
                e.keyCode === slate.utils.keyboardKeys.ENTER && $(this.selectors.productFeaturedImage + ":visible").focus()
            },
            _initThumbnailSlider: function() {
                var e = {
                    slidesToShow: 4,
                    slidesToScroll: 3,
                    infinite: !1,
                    prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
                    nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
                    responsive: [{
                        breakpoint: 321,
                        settings: {
                            slidesToShow: 3
                        }
                    }]
                };
                $(this.selectors.productThumbs).slick(e), $(this.selectors.productThumbsWrapper, this.$container).find(".slick-list").removeAttr("aria-live"), $(this.selectors.productThumbsWrapper, this.$container).find(".slick-disabled").removeAttr("aria-disabled"), this.settings.sliderActive = !0
            },
            _destroyThumbnailSlider: function() {
                $(this.selectors.productThumbs).slick("unslick"), this.settings.sliderActive = !1, $(this.selectors.productThumbsWrapper, this.$container).find('[tabindex="-1"]').removeAttr("tabindex")
            },
            _liveRegionText: function(e) {
                var t = "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";
                if (!e) return t = theme.strings.unavailable;
                var i = e.available ? "" : theme.strings.soldOut + ",";
                t = t.replace("[Availability]", i);
                var n = "",
                    a = theme.Currency.formatMoney(e.price, theme.moneyFormat),
                    r = "",
                    o = "",
                    s = "",
                    c = "";
                return e.compare_at_price > e.price && (n = theme.strings.regularPrice, a = theme.Currency.formatMoney(e.compare_at_price, theme.moneyFormat) + ",", r = theme.strings.sale, o = theme.Currency.formatMoney(e.price, theme.moneyFormat)), e.unit_price && (s = theme.strings.unitPrice, c = theme.Currency.formatMoney(e.unit_price, theme.moneyFormat) + " " + theme.strings.unitPriceSeparator + " " + this._getBaseUnit(e)), t = t.replace("[Regular]", n).replace("[$$]", a).replace("[Sale]", r).replace("[$]", o).replace("[UnitPrice]", s).replace("[$$$]", c).trim()
            },
            _updateLiveRegion: function(e) {
                var t = e.variant,
                    i = this.container.querySelector(this.selectors.productStatus);
                i.textContent = this._liveRegionText(t), i.setAttribute("aria-hidden", !1), setTimeout(function() {
                    i.setAttribute("aria-hidden", !0)
                }, 1e3)
            },
            _updateAddToCart: function(e) {
                var t = e.variant;
                t ? t.available ? (this.$addToCart.removeAttr("aria-disabled").removeAttr("disabled").attr("aria-label", theme.strings.addToCart), $(this.selectors.addToCartText, this.$container).text(theme.strings.addToCart), this.$shopifyPaymentButton.show()) : (this.$addToCart.attr("aria-disabled", !0).attr("disabled", "disabled").attr("aria-label", theme.strings.soldOut), $(this.selectors.addToCartText, this.$container).text(theme.strings.soldOut), this.$shopifyPaymentButton.hide()) : (this.$addToCart.attr("aria-disabled", !0).attr("disabled", "disabled").attr("aria-label", theme.strings.unavailable), $(this.selectors.addToCartText, this.$container).text(theme.strings.unavailable), this.$shopifyPaymentButton.hide())
            },
            _updateAvailability: function(e) {
                this._hideErrorMessage(), this._updateAddToCart(e), this._updateLiveRegion(e), this._updatePrice(e)
            },
            _updateImages: function(e) {
                var t = e.variant.featured_image.id;
                this._switchImage(t), this._setActiveThumbnail(t)
            },
            _updatePrice: function(e) {
                var t = e.variant,
                    i = $(this.selectors.priceContainer, this.$container),
                    n = $(this.selectors.regularPrice, i),
                    a = $(this.selectors.salePrice, i),
                    r = $(this.selectors.unitPrice, i),
                    o = $(this.selectors.unitPriceBaseUnit, i);
                i.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeClass(this.classes.productUnitAvailable).removeAttr("aria-hidden"), t ? (t.compare_at_price > t.price ? (n.html(theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat)), a.html(theme.Currency.formatMoney(t.price, theme.moneyFormat)), i.addClass(this.classes.productOnSale)) : n.html(theme.Currency.formatMoney(t.price, theme.moneyFormat)), t.unit_price && (r.html(theme.Currency.formatMoney(t.unit_price, theme.moneyFormat)), o.html(this._getBaseUnit(t)), i.addClass(this.classes.productUnitAvailable))) : i.addClass(this.classes.productUnavailable).attr("aria-hidden", !0)
            },
            _getBaseUnit: function(e) {
                return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
            },
            _updateSKU: function(e) {
                var t = e.variant;
                $(this.selectors.SKU).html(t.sku)
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), e
    }(), theme.ProductRecommendations = function() {
        var e = "[data-product-card]";

        function t(e) {
            this.$container = $(e);
            var t = $(".recommendations-scn").attr("data-limit"),
                i = "/recommendations/products?&section_id=product-recommendations&product_id=" + this.$container.data("productId") + "&limit=" + t;
            $.get(i).then(function(e) {
                var t = $(e).html();
                "" !== t.trim() && (this.$container.html(t), this.sendTrekkieEvent())
            }.bind(this))
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            sendTrekkieEvent: function() {
                if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.track) {
                    var t = this.$container[0].getBoundingClientRect().top <= window.innerHeight,
                        i = this.$container.find(e).length;
                    window.ShopifyAnalytics.lib.track("Product Recommendations Displayed", {
                        theme: "armedforcesgear",
                        didPageJumpOccur: t,
                        numberOfRecommendationsDisplayed: i
                    })
                }
            }
        }), t
    }(), theme.Quotes = function() {
        var e = {
                mediaQuerySmall: "screen and (max-width: 749px)",
                mediaQueryMediumUp: "screen and (min-width: 750px)",
                slideCount: 0
            },
            t = {
                accessibility: !0,
                arrows: !1,
                dots: !0,
                autoplay: !1,
                touchThreshold: 20,
                slidesToShow: 3,
                slidesToScroll: 3
            };

        function i(i) {
            var n = (this.$container = $(i)).attr("data-section-id"),
                a = this.wrapper = ".quotes-wrapper",
                r = this.slider = "#Quotes-" + n,
                o = $(r, a),
                s = !1,
                c = $.extend({}, t, {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: !0
                });

            function l(e, t) {
                s && (e.slick("unslick"), s = !1), e.slick(t), s = !0
            }
            e.slideCount = o.data("count"), e.slideCount < t.slidesToShow && (t.slidesToShow = e.slideCount, t.slidesToScroll = e.slideCount), o.on("init", this.a11y.bind(this)), enquire.register(e.mediaQuerySmall, {
                match: function() {
                    l(o, c)
                }
            }), enquire.register(e.mediaQueryMediumUp, {
                match: function() {
                    l(o, t)
                }
            })
        }
        return i.prototype = _.assignIn({}, i.prototype, {
            onUnload: function() {
                enquire.unregister(e.mediaQuerySmall), enquire.unregister(e.mediaQueryMediumUp), $(this.slider, this.wrapper).slick("unslick")
            },
            onBlockSelect: function(e) {
                var t = $(".quotes-slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                $(this.slider, this.wrapper).slick("slickGoTo", t)
            },
            a11y: function(e, t) {
                var i = t.$list,
                    n = $(this.wrapper, this.$container);
                i.removeAttr("aria-live"), n.on("focusin", function(e) {
                    n.has(e.target).length && i.attr("aria-live", "polite")
                }), n.on("focusout", function(e) {
                    n.has(e.target).length && i.removeAttr("aria-live")
                })
            }
        }), i
    }(), theme.slideshows = {}, theme.SlideshowSection = function() {
        return function(e) {
            var t = (this.$container = $(e)).attr("data-section-id"),
                i = this.slideshow = "#Slideshow-" + t;
            theme.slideshows[i] = new theme.Slideshow(i, t)
        }
    }(), theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
        onUnload: function() {
            delete theme.slideshows[this.slideshow]
        },
        onBlockSelect: function(e) {
            var t = $(this.slideshow);
            t.data("adapt-height") && theme.slideshows[this.slideshow].setSlideshowHeight();
            var i = $(".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            t.slick("slickGoTo", i).slick("slickPause")
        },
        onBlockDeselect: function() {
            $(this.slideshow).slick("slickPlay")
        }
    }), theme.slideshows = {}, theme.VideoSection = function() {
        return function(e) {
            var t = this.$container = $(e);
            $(".video", t).each(function() {
                var e = $(this);
                theme.Video.init(e), theme.Video.editorLoadVideo(e.attr("id"))
            })
        }
    }(), theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
        onUnload: function() {
            theme.Video.removeEvents()
        }
    }), theme.heros = {}, theme.HeroSection = function() {
        return function(e) {
            var t = (this.$container = $(e)).attr("data-section-id"),
                i = "#Hero-" + t;
            theme.heros[i] = new theme.Hero(i, t)
        }
    }();
var Shopify = Shopify || {};
Shopify.money_format = window.theme.moneyFormat, Shopify.formatMoney = function(e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    var i = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        a = t || this.money_format;

    function r(e, t) {
        return void 0 === e ? t : e
    }

    function o(e, t, i, n) {
        if (t = r(t, 2), i = r(i, ","), n = r(n, "."), isNaN(e) || null == e) return 0;
        var a = (e = (e / 100).toFixed(t)).split(".");
        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "")
    }
    switch (a.match(n)[1]) {
        case "amount":
            i = o(e, 2);
            break;
        case "amount_no_decimals":
            i = o(e, 0);
            break;
        case "amount_with_comma_separator":
            i = o(e, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            i = o(e, 0, ".", ",")
    }
    return a.replace(n, i)
}, setTimeout(function() {
    var e = new theme.Sections;
    e.register("cart-template", theme.Cart), e.register("product", theme.Product), e.register("collection-template", theme.Filters), e.register("product-template", theme.Product), e.register("header-section", theme.HeaderSection), e.register("map", theme.Maps), e.register("slideshow-section", theme.SlideshowSection), e.register("video-section", theme.VideoSection), e.register("quotes", theme.Quotes), e.register("hero-section", theme.HeroSection), e.register("product-recommendations", theme.ProductRecommendations)
}), theme.init = function() {
    theme.customerTemplates.init();
    slate.rte.wrapTable({
        $tables: $(".rte table,.custom__item-inner--html table"),
        tableWrapperClass: "scrollable-wrapper"
    });
    slate.rte.wrapIframe({
        $iframes: $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]'),
        iframeWrapperClass: "video-wrapper"
    }), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(e) {
        slate.a11y.pageLinkFocus($(e.currentTarget.hash))
    }), $('a[href="#"]').on("click", function(e) {
        e.preventDefault()
    }), slate.a11y.accessibleLinks({
        messages: {
            newWindow: theme.strings.newWindow,
            external: theme.strings.external,
            newWindowExternal: theme.strings.newWindowExternal
        },
        $links: $("a[href]:not([aria-describedby], .product-single__thumbnail)")
    }), theme.FormStatus.init();
    var e = {
            image: "[data-image]",
            imagePlaceholder: "[data-image-placeholder]",
            imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]"
        },
        t = {
            hidden: "hide"
        };

    function i(e) {
        var t = $("#minicart-template").html(),
            i = $variable.template(t);
        $("#mini-cart").html(i({
            cart: e
        })), $(".price", "#mini-cart").each(function() {
            $(this).html(Shopify.formatMoney(parseFloat($(this).text())))
        }), $("img", "#mini-cart").each(function() {
            var e = $(this).attr("src");
            e = (e = e.replace(".jpg", "_78x78.jpg")).replace(".jpeg", "_78x78.jpeg"), $(this).attr("src", e)
        })
    }
    $(document).on("lazyloaded", function(i) {
            var n = $(i.target);
            n.is(e.image) && n.closest(e.imageWithPlaceholderWrapper).find(e.imagePlaceholder).addClass(t.hidden)
        }), $(e.image + ".lazyloaded").closest(e.imageWithPlaceholderWrapper).find(e.imagePlaceholder).addClass(t.hidden),
        function() {
            var e = "object" == typeof self && self.self === self && self || "object" == typeof global && global.global === global && global || this || {},
                t = e._,
                i = Array.prototype,
                n = Object.prototype,
                a = "undefined" != typeof Symbol ? Symbol.prototype : null,
                r = i.push,
                o = i.slice,
                s = n.toString,
                c = n.hasOwnProperty,
                l = Array.isArray,
                u = Object.keys,
                d = Object.create,
                h = function() {},
                p = function(e) {
                    return e instanceof p ? e : this instanceof p ? void(this._wrapped = e) : new p(e)
                };
            "undefined" == typeof exports || exports.nodeType ? e._ = p : ("undefined" != typeof module && !module.nodeType && module.exports && (exports = module.exports = p), exports._ = p), p.VERSION = "1.9.1";
            var f, m = function(e, t, i) {
                    if (void 0 === t) return e;
                    switch (null == i ? 3 : i) {
                        case 1:
                            return function(i) {
                                return e.call(t, i)
                            };
                        case 3:
                            return function(i, n, a) {
                                return e.call(t, i, n, a)
                            };
                        case 4:
                            return function(i, n, a, r) {
                                return e.call(t, i, n, a, r)
                            }
                    }
                    return function() {
                        return e.apply(t, arguments)
                    }
                },
                v = function(e, t, i) {
                    return p.iteratee !== f ? p.iteratee(e, t) : null == e ? p.identity : p.isFunction(e) ? m(e, t, i) : p.isObject(e) && !p.isArray(e) ? p.matcher(e) : p.property(e)
                };
            p.iteratee = f = function(e, t) {
                return v(e, t, 1 / 0)
            };
            var g = function(e, t) {
                    return t = null == t ? e.length - 1 : +t,
                        function() {
                            for (var i = Math.max(arguments.length - t, 0), n = Array(i), a = 0; a < i; a++) n[a] = arguments[a + t];
                            switch (t) {
                                case 0:
                                    return e.call(this, n);
                                case 1:
                                    return e.call(this, arguments[0], n);
                                case 2:
                                    return e.call(this, arguments[0], arguments[1], n)
                            }
                            var r = Array(t + 1);
                            for (a = 0; a < t; a++) r[a] = arguments[a];
                            return r[t] = n, e.apply(this, r)
                        }
                },
                $ = function(e) {
                    if (!p.isObject(e)) return {};
                    if (d) return d(e);
                    h.prototype = e;
                    var t = new h;
                    return h.prototype = null, t
                },
                y = function(e) {
                    return function(t) {
                        return null == t ? void 0 : t[e]
                    }
                },
                b = function(e, t) {
                    return null != e && c.call(e, t)
                },
                w = function(e, t) {
                    for (var i = t.length, n = 0; n < i; n++) {
                        if (null == e) return;
                        e = e[t[n]]
                    }
                    return i ? e : void 0
                },
                _ = Math.pow(2, 53) - 1,
                C = y("length"),
                k = function(e) {
                    var t = C(e);
                    return "number" == typeof t && t >= 0 && t <= _
                };
            p.each = p.forEach = function(e, t, i) {
                var n, a;
                if (t = m(t, i), k(e))
                    for (n = 0, a = e.length; n < a; n++) t(e[n], n, e);
                else {
                    var r = p.keys(e);
                    for (n = 0, a = r.length; n < a; n++) t(e[r[n]], r[n], e)
                }
                return e
            }, p.map = p.collect = function(e, t, i) {
                t = v(t, i);
                for (var n = !k(e) && p.keys(e), a = (n || e).length, r = Array(a), o = 0; o < a; o++) {
                    var s = n ? n[o] : o;
                    r[o] = t(e[s], s, e)
                }
                return r
            };
            var S = function(e) {
                return function(t, i, n, a) {
                    var r = arguments.length >= 3;
                    return function(t, i, n, a) {
                        var r = !k(t) && p.keys(t),
                            o = (r || t).length,
                            s = e > 0 ? 0 : o - 1;
                        for (a || (n = t[r ? r[s] : s], s += e); s >= 0 && s < o; s += e) {
                            var c = r ? r[s] : s;
                            n = i(n, t[c], c, t)
                        }
                        return n
                    }(t, m(i, a, 4), n, r)
                }
            };
            p.reduce = p.foldl = p.inject = S(1), p.reduceRight = p.foldr = S(-1), p.find = p.detect = function(e, t, i) {
                var n = (k(e) ? p.findIndex : p.findKey)(e, t, i);
                if (void 0 !== n && -1 !== n) return e[n]
            }, p.filter = p.select = function(e, t, i) {
                var n = [];
                return t = v(t, i), p.each(e, function(e, i, a) {
                    t(e, i, a) && n.push(e)
                }), n
            }, p.reject = function(e, t, i) {
                return p.filter(e, p.negate(v(t)), i)
            }, p.every = p.all = function(e, t, i) {
                t = v(t, i);
                for (var n = !k(e) && p.keys(e), a = (n || e).length, r = 0; r < a; r++) {
                    var o = n ? n[r] : r;
                    if (!t(e[o], o, e)) return !1
                }
                return !0
            }, p.some = p.any = function(e, t, i) {
                t = v(t, i);
                for (var n = !k(e) && p.keys(e), a = (n || e).length, r = 0; r < a; r++) {
                    var o = n ? n[r] : r;
                    if (t(e[o], o, e)) return !0
                }
                return !1
            }, p.contains = p.includes = p.include = function(e, t, i, n) {
                return k(e) || (e = p.values(e)), ("number" != typeof i || n) && (i = 0), p.indexOf(e, t, i) >= 0
            }, p.invoke = g(function(e, t, i) {
                var n, a;
                return p.isFunction(t) ? a = t : p.isArray(t) && (n = t.slice(0, -1), t = t[t.length - 1]), p.map(e, function(e) {
                    var r = a;
                    if (!r) {
                        if (n && n.length && (e = w(e, n)), null == e) return;
                        r = e[t]
                    }
                    return null == r ? r : r.apply(e, i)
                })
            }), p.pluck = function(e, t) {
                return p.map(e, p.property(t))
            }, p.where = function(e, t) {
                return p.filter(e, p.matcher(t))
            }, p.findWhere = function(e, t) {
                return p.find(e, p.matcher(t))
            }, p.max = function(e, t, i) {
                var n, a, r = -1 / 0,
                    o = -1 / 0;
                if (null == t || "number" == typeof t && "object" != typeof e[0] && null != e)
                    for (var s = 0, c = (e = k(e) ? e : p.values(e)).length; s < c; s++) null != (n = e[s]) && n > r && (r = n);
                else t = v(t, i), p.each(e, function(e, i, n) {
                    ((a = t(e, i, n)) > o || a === -1 / 0 && r === -1 / 0) && (r = e, o = a)
                });
                return r
            }, p.min = function(e, t, i) {
                var n, a, r = 1 / 0,
                    o = 1 / 0;
                if (null == t || "number" == typeof t && "object" != typeof e[0] && null != e)
                    for (var s = 0, c = (e = k(e) ? e : p.values(e)).length; s < c; s++) null != (n = e[s]) && n < r && (r = n);
                else t = v(t, i), p.each(e, function(e, i, n) {
                    ((a = t(e, i, n)) < o || a === 1 / 0 && r === 1 / 0) && (r = e, o = a)
                });
                return r
            }, p.shuffle = function(e) {
                return p.sample(e, 1 / 0)
            }, p.sample = function(e, t, i) {
                if (null == t || i) return k(e) || (e = p.values(e)), e[p.random(e.length - 1)];
                var n = k(e) ? p.clone(e) : p.values(e),
                    a = C(n);
                t = Math.max(Math.min(t, a), 0);
                for (var r = a - 1, o = 0; o < t; o++) {
                    var s = p.random(o, r),
                        c = n[o];
                    n[o] = n[s], n[s] = c
                }
                return n.slice(0, t)
            }, p.sortBy = function(e, t, i) {
                var n = 0;
                return t = v(t, i), p.pluck(p.map(e, function(e, i, a) {
                    return {
                        value: e,
                        index: n++,
                        criteria: t(e, i, a)
                    }
                }).sort(function(e, t) {
                    var i = e.criteria,
                        n = t.criteria;
                    if (i !== n) {
                        if (i > n || void 0 === i) return 1;
                        if (i < n || void 0 === n) return -1
                    }
                    return e.index - t.index
                }), "value")
            };
            var P = function(e, t) {
                return function(i, n, a) {
                    var r = t ? [
                        [],
                        []
                    ] : {};
                    return n = v(n, a), p.each(i, function(t, a) {
                        var o = n(t, a, i);
                        e(r, t, o)
                    }), r
                }
            };
            p.groupBy = P(function(e, t, i) {
                b(e, i) ? e[i].push(t) : e[i] = [t]
            }), p.indexBy = P(function(e, t, i) {
                e[i] = t
            }), p.countBy = P(function(e, t, i) {
                b(e, i) ? e[i]++ : e[i] = 1
            });
            var T = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
            p.toArray = function(e) {
                return e ? p.isArray(e) ? o.call(e) : p.isString(e) ? e.match(T) : k(e) ? p.map(e, p.identity) : p.values(e) : []
            }, p.size = function(e) {
                return null == e ? 0 : k(e) ? e.length : p.keys(e).length
            }, p.partition = P(function(e, t, i) {
                e[i ? 0 : 1].push(t)
            }, !0), p.first = p.head = p.take = function(e, t, i) {
                return null == e || e.length < 1 ? null == t ? void 0 : [] : null == t || i ? e[0] : p.initial(e, e.length - t)
            }, p.initial = function(e, t, i) {
                return o.call(e, 0, Math.max(0, e.length - (null == t || i ? 1 : t)))
            }, p.last = function(e, t, i) {
                return null == e || e.length < 1 ? null == t ? void 0 : [] : null == t || i ? e[e.length - 1] : p.rest(e, Math.max(0, e.length - t))
            }, p.rest = p.tail = p.drop = function(e, t, i) {
                return o.call(e, null == t || i ? 1 : t)
            }, p.compact = function(e) {
                return p.filter(e, Boolean)
            };
            var x = function(e, t, i, n) {
                for (var a = (n = n || []).length, r = 0, o = C(e); r < o; r++) {
                    var s = e[r];
                    if (k(s) && (p.isArray(s) || p.isArguments(s)))
                        if (t)
                            for (var c = 0, l = s.length; c < l;) n[a++] = s[c++];
                        else x(s, t, i, n), a = n.length;
                    else i || (n[a++] = s)
                }
                return n
            };
            p.flatten = function(e, t) {
                return x(e, t, !1)
            }, p.without = g(function(e, t) {
                return p.difference(e, t)
            }), p.uniq = p.unique = function(e, t, i, n) {
                p.isBoolean(t) || (n = i, i = t, t = !1), null != i && (i = v(i, n));
                for (var a = [], r = [], o = 0, s = C(e); o < s; o++) {
                    var c = e[o],
                        l = i ? i(c, o, e) : c;
                    t && !i ? (o && r === l || a.push(c), r = l) : i ? p.contains(r, l) || (r.push(l), a.push(c)) : p.contains(a, c) || a.push(c)
                }
                return a
            }, p.union = g(function(e) {
                return p.uniq(x(e, !0, !0))
            }), p.intersection = function(e) {
                for (var t = [], i = arguments.length, n = 0, a = C(e); n < a; n++) {
                    var r = e[n];
                    if (!p.contains(t, r)) {
                        var o;
                        for (o = 1; o < i && p.contains(arguments[o], r); o++);
                        o === i && t.push(r)
                    }
                }
                return t
            }, p.difference = g(function(e, t) {
                return t = x(t, !0, !0), p.filter(e, function(e) {
                    return !p.contains(t, e)
                })
            }), p.unzip = function(e) {
                for (var t = e && p.max(e, C).length || 0, i = Array(t), n = 0; n < t; n++) i[n] = p.pluck(e, n);
                return i
            }, p.zip = g(p.unzip), p.object = function(e, t) {
                for (var i = {}, n = 0, a = C(e); n < a; n++) t ? i[e[n]] = t[n] : i[e[n][0]] = e[n][1];
                return i
            };
            var I = function(e) {
                return function(t, i, n) {
                    i = v(i, n);
                    for (var a = C(t), r = e > 0 ? 0 : a - 1; r >= 0 && r < a; r += e)
                        if (i(t[r], r, t)) return r;
                    return -1
                }
            };
            p.findIndex = I(1), p.findLastIndex = I(-1), p.sortedIndex = function(e, t, i, n) {
                for (var a = (i = v(i, n, 1))(t), r = 0, o = C(e); r < o;) {
                    var s = Math.floor((r + o) / 2);
                    i(e[s]) < a ? r = s + 1 : o = s
                }
                return r
            };
            var N = function(e, t, i) {
                return function(n, a, r) {
                    var s = 0,
                        c = C(n);
                    if ("number" == typeof r) e > 0 ? s = r >= 0 ? r : Math.max(r + c, s) : c = r >= 0 ? Math.min(r + 1, c) : r + c + 1;
                    else if (i && r && c) return n[r = i(n, a)] === a ? r : -1;
                    if (a != a) return (r = t(o.call(n, s, c), p.isNaN)) >= 0 ? r + s : -1;
                    for (r = e > 0 ? s : c - 1; r >= 0 && r < c; r += e)
                        if (n[r] === a) return r;
                    return -1
                }
            };
            p.indexOf = N(1, p.findIndex, p.sortedIndex), p.lastIndexOf = N(-1, p.findLastIndex), p.range = function(e, t, i) {
                null == t && (t = e || 0, e = 0), i || (i = t < e ? -1 : 1);
                for (var n = Math.max(Math.ceil((t - e) / i), 0), a = Array(n), r = 0; r < n; r++, e += i) a[r] = e;
                return a
            }, p.chunk = function(e, t) {
                if (null == t || t < 1) return [];
                for (var i = [], n = 0, a = e.length; n < a;) i.push(o.call(e, n, n += t));
                return i
            };
            var A = function(e, t, i, n, a) {
                if (!(n instanceof t)) return e.apply(i, a);
                var r = $(e.prototype),
                    o = e.apply(r, a);
                return p.isObject(o) ? o : r
            };
            p.bind = g(function(e, t, i) {
                if (!p.isFunction(e)) throw new TypeError("Bind must be called on a function");
                var n = g(function(a) {
                    return A(e, n, t, this, i.concat(a))
                });
                return n
            }), p.partial = g(function(e, t) {
                var i = p.partial.placeholder,
                    n = function() {
                        for (var a = 0, r = t.length, o = Array(r), s = 0; s < r; s++) o[s] = t[s] === i ? arguments[a++] : t[s];
                        for (; a < arguments.length;) o.push(arguments[a++]);
                        return A(e, n, this, this, o)
                    };
                return n
            }), p.partial.placeholder = p, p.bindAll = g(function(e, t) {
                var i = (t = x(t, !1, !1)).length;
                if (i < 1) throw new Error("bindAll must be passed function names");
                for (; i--;) {
                    var n = t[i];
                    e[n] = p.bind(e[n], e)
                }
            }), p.memoize = function(e, t) {
                var i = function(n) {
                    var a = i.cache,
                        r = "" + (t ? t.apply(this, arguments) : n);
                    return b(a, r) || (a[r] = e.apply(this, arguments)), a[r]
                };
                return i.cache = {}, i
            }, p.delay = g(function(e, t, i) {
                return setTimeout(function() {
                    return e.apply(null, i)
                }, t)
            }), p.defer = p.partial(p.delay, p, 1), p.throttle = function(e, t, i) {
                var n, a, r, o, s = 0;
                i || (i = {});
                var c = function() {
                        s = !1 === i.leading ? 0 : p.now(), n = null, o = e.apply(a, r), n || (a = r = null)
                    },
                    l = function() {
                        var l = p.now();
                        s || !1 !== i.leading || (s = l);
                        var u = t - (l - s);
                        return a = this, r = arguments, u <= 0 || u > t ? (n && (clearTimeout(n), n = null), s = l, o = e.apply(a, r), n || (a = r = null)) : n || !1 === i.trailing || (n = setTimeout(c, u)), o
                    };
                return l.cancel = function() {
                    clearTimeout(n), s = 0, n = a = r = null
                }, l
            }, p.debounce = function(e, t, i) {
                var n, a, r = function(t, i) {
                        n = null, i && (a = e.apply(t, i))
                    },
                    o = g(function(o) {
                        if (n && clearTimeout(n), i) {
                            var s = !n;
                            n = setTimeout(r, t), s && (a = e.apply(this, o))
                        } else n = p.delay(r, t, this, o);
                        return a
                    });
                return o.cancel = function() {
                    clearTimeout(n), n = null
                }, o
            }, p.wrap = function(e, t) {
                return p.partial(t, e)
            }, p.negate = function(e) {
                return function() {
                    return !e.apply(this, arguments)
                }
            }, p.compose = function() {
                var e = arguments,
                    t = e.length - 1;
                return function() {
                    for (var i = t, n = e[t].apply(this, arguments); i--;) n = e[i].call(this, n);
                    return n
                }
            }, p.after = function(e, t) {
                return function() {
                    if (--e < 1) return t.apply(this, arguments)
                }
            }, p.before = function(e, t) {
                var i;
                return function() {
                    return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = null), i
                }
            }, p.once = p.partial(p.before, 2), p.restArguments = g;
            var E = !{
                    toString: null
                }.propertyIsEnumerable("toString"),
                M = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
                W = function(e, t) {
                    var i = M.length,
                        a = e.constructor,
                        r = p.isFunction(a) && a.prototype || n,
                        o = "constructor";
                    for (b(e, o) && !p.contains(t, o) && t.push(o); i--;)(o = M[i]) in e && e[o] !== r[o] && !p.contains(t, o) && t.push(o)
                };
            p.keys = function(e) {
                if (!p.isObject(e)) return [];
                if (u) return u(e);
                var t = [];
                for (var i in e) b(e, i) && t.push(i);
                return E && W(e, t), t
            }, p.allKeys = function(e) {
                if (!p.isObject(e)) return [];
                var t = [];
                for (var i in e) t.push(i);
                return E && W(e, t), t
            }, p.values = function(e) {
                for (var t = p.keys(e), i = t.length, n = Array(i), a = 0; a < i; a++) n[a] = e[t[a]];
                return n
            }, p.mapObject = function(e, t, i) {
                t = v(t, i);
                for (var n = p.keys(e), a = n.length, r = {}, o = 0; o < a; o++) {
                    var s = n[o];
                    r[s] = t(e[s], s, e)
                }
                return r
            }, p.pairs = function(e) {
                for (var t = p.keys(e), i = t.length, n = Array(i), a = 0; a < i; a++) n[a] = [t[a], e[t[a]]];
                return n
            }, p.invert = function(e) {
                for (var t = {}, i = p.keys(e), n = 0, a = i.length; n < a; n++) t[e[i[n]]] = i[n];
                return t
            }, p.functions = p.methods = function(e) {
                var t = [];
                for (var i in e) p.isFunction(e[i]) && t.push(i);
                return t.sort()
            };
            var D = function(e, t) {
                return function(i) {
                    var n = arguments.length;
                    if (t && (i = Object(i)), n < 2 || null == i) return i;
                    for (var a = 1; a < n; a++)
                        for (var r = arguments[a], o = e(r), s = o.length, c = 0; c < s; c++) {
                            var l = o[c];
                            t && void 0 !== i[l] || (i[l] = r[l])
                        }
                    return i
                }
            };
            p.extend = D(p.allKeys), p.extendOwn = p.assign = D(p.keys), p.findKey = function(e, t, i) {
                t = v(t, i);
                for (var n, a = p.keys(e), r = 0, o = a.length; r < o; r++)
                    if (t(e[n = a[r]], n, e)) return n
            };
            var F, O, H = function(e, t, i) {
                return t in i
            };
            p.pick = g(function(e, t) {
                var i = {},
                    n = t[0];
                if (null == e) return i;
                p.isFunction(n) ? (t.length > 1 && (n = m(n, t[1])), t = p.allKeys(e)) : (n = H, t = x(t, !1, !1), e = Object(e));
                for (var a = 0, r = t.length; a < r; a++) {
                    var o = t[a],
                        s = e[o];
                    n(s, o, e) && (i[o] = s)
                }
                return i
            }), p.omit = g(function(e, t) {
                var i, n = t[0];
                return p.isFunction(n) ? (n = p.negate(n), t.length > 1 && (i = t[1])) : (t = p.map(x(t, !1, !1), String), n = function(e, i) {
                    return !p.contains(t, i)
                }), p.pick(e, n, i)
            }), p.defaults = D(p.allKeys, !0), p.create = function(e, t) {
                var i = $(e);
                return t && p.extendOwn(i, t), i
            }, p.clone = function(e) {
                return p.isObject(e) ? p.isArray(e) ? e.slice() : p.extend({}, e) : e
            }, p.tap = function(e, t) {
                return t(e), e
            }, p.isMatch = function(e, t) {
                var i = p.keys(t),
                    n = i.length;
                if (null == e) return !n;
                for (var a = Object(e), r = 0; r < n; r++) {
                    var o = i[r];
                    if (t[o] !== a[o] || !(o in a)) return !1
                }
                return !0
            }, F = function(e, t, i, n) {
                if (e === t) return 0 !== e || 1 / e == 1 / t;
                if (null == e || null == t) return !1;
                if (e != e) return t != t;
                var a = typeof e;
                return ("function" === a || "object" === a || "object" == typeof t) && O(e, t, i, n)
            }, O = function(e, t, i, n) {
                e instanceof p && (e = e._wrapped), t instanceof p && (t = t._wrapped);
                var r = s.call(e);
                if (r !== s.call(t)) return !1;
                switch (r) {
                    case "[object RegExp]":
                    case "[object String]":
                        return "" + e == "" + t;
                    case "[object Number]":
                        return +e != +e ? +t != +t : 0 == +e ? 1 / +e == 1 / t : +e == +t;
                    case "[object Date]":
                    case "[object Boolean]":
                        return +e == +t;
                    case "[object Symbol]":
                        return a.valueOf.call(e) === a.valueOf.call(t)
                }
                var o = "[object Array]" === r;
                if (!o) {
                    if ("object" != typeof e || "object" != typeof t) return !1;
                    var c = e.constructor,
                        l = t.constructor;
                    if (c !== l && !(p.isFunction(c) && c instanceof c && p.isFunction(l) && l instanceof l) && "constructor" in e && "constructor" in t) return !1
                }
                n = n || [];
                for (var u = (i = i || []).length; u--;)
                    if (i[u] === e) return n[u] === t;
                if (i.push(e), n.push(t), o) {
                    if ((u = e.length) !== t.length) return !1;
                    for (; u--;)
                        if (!F(e[u], t[u], i, n)) return !1
                } else {
                    var d, h = p.keys(e);
                    if (u = h.length, p.keys(t).length !== u) return !1;
                    for (; u--;)
                        if (d = h[u], !b(t, d) || !F(e[d], t[d], i, n)) return !1
                }
                return i.pop(), n.pop(), !0
            }, p.isEqual = function(e, t) {
                return F(e, t)
            }, p.isEmpty = function(e) {
                return null == e || (k(e) && (p.isArray(e) || p.isString(e) || p.isArguments(e)) ? 0 === e.length : 0 === p.keys(e).length)
            }, p.isElement = function(e) {
                return !(!e || 1 !== e.nodeType)
            }, p.isArray = l || function(e) {
                return "[object Array]" === s.call(e)
            }, p.isObject = function(e) {
                var t = typeof e;
                return "function" === t || "object" === t && !!e
            }, p.each(["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error", "Symbol", "Map", "WeakMap", "Set", "WeakSet"], function(e) {
                p["is" + e] = function(t) {
                    return s.call(t) === "[object " + e + "]"
                }
            }), p.isArguments(arguments) || (p.isArguments = function(e) {
                return b(e, "callee")
            });
            var B = e.document && e.document.childNodes;
            "function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof B && (p.isFunction = function(e) {
                return "function" == typeof e || !1
            }), p.isFinite = function(e) {
                return !p.isSymbol(e) && isFinite(e) && !isNaN(parseFloat(e))
            }, p.isNaN = function(e) {
                return p.isNumber(e) && isNaN(e)
            }, p.isBoolean = function(e) {
                return !0 === e || !1 === e || "[object Boolean]" === s.call(e)
            }, p.isNull = function(e) {
                return null === e
            }, p.isUndefined = function(e) {
                return void 0 === e
            }, p.has = function(e, t) {
                if (!p.isArray(t)) return b(e, t);
                for (var i = t.length, n = 0; n < i; n++) {
                    var a = t[n];
                    if (null == e || !c.call(e, a)) return !1;
                    e = e[a]
                }
                return !!i
            }, p.noConflict = function() {
                return e._ = t, this
            }, p.identity = function(e) {
                return e
            }, p.constant = function(e) {
                return function() {
                    return e
                }
            }, p.noop = function() {}, p.property = function(e) {
                return p.isArray(e) ? function(t) {
                    return w(t, e)
                } : y(e)
            }, p.propertyOf = function(e) {
                return null == e ? function() {} : function(t) {
                    return p.isArray(t) ? w(e, t) : e[t]
                }
            }, p.matcher = p.matches = function(e) {
                return e = p.extendOwn({}, e),
                    function(t) {
                        return p.isMatch(t, e)
                    }
            }, p.times = function(e, t, i) {
                var n = Array(Math.max(0, e));
                t = m(t, i, 1);
                for (var a = 0; a < e; a++) n[a] = t(a);
                return n
            }, p.random = function(e, t) {
                return null == t && (t = e, e = 0), e + Math.floor(Math.random() * (t - e + 1))
            }, p.now = Date.now || function() {
                return (new Date).getTime()
            };
            var j = {
                    "&": "&amp;",
                    "<": "&lt;",
                    ">": "&gt;",
                    '"': "&quot;",
                    "'": "&#x27;",
                    "`": "&#x60;"
                },
                L = p.invert(j),
                R = function(e) {
                    var t = function(t) {
                            return e[t]
                        },
                        i = "(?:" + p.keys(e).join("|") + ")",
                        n = RegExp(i),
                        a = RegExp(i, "g");
                    return function(e) {
                        return e = null == e ? "" : "" + e, n.test(e) ? e.replace(a, t) : e
                    }
                };
            p.escape = R(j), p.unescape = R(L), p.result = function(e, t, i) {
                p.isArray(t) || (t = [t]);
                var n = t.length;
                if (!n) return p.isFunction(i) ? i.call(e) : i;
                for (var a = 0; a < n; a++) {
                    var r = null == e ? void 0 : e[t[a]];
                    void 0 === r && (r = i, a = n), e = p.isFunction(r) ? r.call(e) : r
                }
                return e
            };
            var V = 0;
            p.uniqueId = function(e) {
                var t = ++V + "";
                return e ? e + t : t
            }, p.templateSettings = {
                evaluate: /<%([\s\S]+?)%>/g,
                interpolate: /<%=([\s\S]+?)%>/g,
                escape: /<%-([\s\S]+?)%>/g
            };
            var U = /(.)^/,
                q = {
                    "'": "'",
                    "\\": "\\",
                    "\r": "r",
                    "\n": "n",
                    "\u2028": "u2028",
                    "\u2029": "u2029"
                },
                Q = /\\|'|\r|\n|\u2028|\u2029/g,
                z = function(e) {
                    return "\\" + q[e]
                };
            p.template = function(e, t, i) {
                !t && i && (t = i), t = p.defaults({}, t, p.templateSettings);
                var n, a = RegExp([(t.escape || U).source, (t.interpolate || U).source, (t.evaluate || U).source].join("|") + "|$", "g"),
                    r = 0,
                    o = "__p+='";
                e.replace(a, function(t, i, n, a, s) {
                    return o += e.slice(r, s).replace(Q, z), r = s + t.length, i ? o += "'+\n((__t=(" + i + "))==null?'':_.escape(__t))+\n'" : n ? o += "'+\n((__t=(" + n + "))==null?'':__t)+\n'" : a && (o += "';\n" + a + "\n__p+='"), t
                }), o += "';\n", t.variable || (o = "with(obj||{}){\n" + o + "}\n"), o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
                try {
                    n = new Function(t.variable || "obj", "_", o)
                } catch (e) {
                    throw e.source = o, e
                }
                var s = function(e) {
                        return n.call(this, e, p)
                    },
                    c = t.variable || "obj";
                return s.source = "function(" + c + "){\n" + o + "}", s
            }, p.chain = function(e) {
                var t = p(e);
                return t._chain = !0, t
            };
            var K = function(e, t) {
                return e._chain ? p(t).chain() : t
            };
            p.mixin = function(e) {
                return p.each(p.functions(e), function(t) {
                    var i = p[t] = e[t];
                    p.prototype[t] = function() {
                        var e = [this._wrapped];
                        return r.apply(e, arguments), K(this, i.apply(p, e))
                    }
                }), p
            }, p.mixin(p), p.each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function(e) {
                var t = i[e];
                p.prototype[e] = function() {
                    var i = this._wrapped;
                    return t.apply(i, arguments), "shift" !== e && "splice" !== e || 0 !== i.length || delete i[0], K(this, i)
                }
            }), p.each(["concat", "join", "slice"], function(e) {
                var t = i[e];
                p.prototype[e] = function() {
                    return K(this, t.apply(this._wrapped, arguments))
                }
            }), p.prototype.value = function() {
                return this._wrapped
            }, p.prototype.valueOf = p.prototype.toJSON = p.prototype.value, p.prototype.toString = function() {
                return String(this._wrapped)
            }, "function" == typeof define && define.amd && define("underscore", [], function() {
                return p
            })
        }(), $variable = _, $theme = window.theme, $(".site-header__cart").on("mouseenter", function() {
            $.getJSON("/cart.js", function(e) {
                i(e),loadMinicartContent(), window.loyaltylion && window.loyaltylion.ui.refresh()
            })
        }), $(document).on("click", ".rembtn", function(e) {
            var t = $("#CartCount .data-cart-count").text(),
                n = $(this).attr("data-qty");
            $line = $(this).data("line");
            var a = {
                line: $line,
                quantity: 0
            };
            $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: a,
                success: function(e) {
                    i(e);
                    var a = parseInt(t) - parseInt(n);
                    $("#CartCount .data-cart-count").html(a),discountMessage(e), loadMinicartContent(), window.loyaltylion && window.loyaltylion.ui.refresh()
                },
                fail: function() {
                    alert("request fail..")
                },
                dataType: "json"
            })
        }), $(document).on("change", ".qty-change", function() {
            var t = $("#CartCount .data-cart-count").text(),
                n = this.value;
            $line = $(this).data("line");
            var a = {
                line: $line,
                quantity: n
            };
            $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: a,
                success: function(e) {
                    i(e);
                    var a = parseInt(t) - parseInt(n);
                    $("#CartCount .data-cart-count").html(e.item_count),discountMessage(e), loadMinicartContent(), window.loyaltylion && window.loyaltylion.ui.refresh()
                },
                fail: function() {
                    alert("request fail..")
                },
                dataType: "json"
            })
        }), $(document).on("click", ".site-header__cart", function(e) {
            e.preventDefault(), $("#mini-cart").addClass("show_mini_cart"), $(".m_c_fixed").addClass("m_c_close"), window.loyaltylion && window.loyaltylion.ui.refresh()
        }), $(document).on("click", ".m_c_fixed, .min-cart-head .m_c_close", function() {
            $("#mini-cart").removeClass("show_mini_cart"), $(".m_c_fixed").removeClass("m_c_close")
        })
};
setTimeout(function(){
	theme.init();
},3000);
